import * as actionTypes from 'modules/interventions/actionTypes';
import { CHANGE_INTERVENTION_STEP, CHANGE_INTERVENTION_STEP_SUCCESS, CHANGE_INTERVENTION_STEP_FAILURE } from 'modules/steps/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const set = (state, action) => (action.meta?.silent ? state : true);
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.UPDATE_INTERVENTION_REQUEST]: set,
  [actionTypes.UPDATE_INTERVENTION_SUCCESS]: reset,
  [actionTypes.UPDATE_INTERVENTION_FAILURE]: reset,
  [CHANGE_INTERVENTION_STEP]: set,
  [CHANGE_INTERVENTION_STEP_SUCCESS]: reset,
  [CHANGE_INTERVENTION_STEP_FAILURE]: reset,
  [actionTypes.UPDATE_INTERVENTION_TAGS]: set,
  [actionTypes.UPDATE_INTERVENTION_TAGS_SUCCESS]: reset,
  [actionTypes.UPDATE_INTERVENTION_TAGS_FAILURE]: reset,
});
